import { Component, OnInit, AfterContentInit, AfterViewChecked, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CmsStudioService } from '../cms-studio.service';
import { Cms } from '../models/cms.model';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';

@Component({
  selector: 'app-cms-view',
  templateUrl: './cmsview.component.html',
  styleUrls: ['../cmsstudio.component.css'],
  //encapsulation: ViewEncapsulation.None,
})

export class CmsViewComponent implements OnInit {
  title: string = "CMS - Studio";
  setFullWindow = false;
  subWidth: string;
  cms: Array<Cms> = [];
  tags: Array<string> = [];
  component: any;
  currentUserModel: CurrentUserModel;
  constructor(
    private router: Router,
    private ngProgress: NgProgress,
    private activeRouter: ActivatedRoute,
    private cmsStudioService: CmsStudioService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
    
    this.cmsStudioService.getAllActiveCms(this.currentUserModel.companyCode)
      .subscribe(res => {
        console.log(res);
        if (res.stat == "success") {
          this.cms = res.cms;
          this.cms.forEach(cm => {
            /*if (cm.tags) {
              cm.tags.forEach(tag => {
                if (this.tags.indexOf(tag) < 0) {
                  this.tags.push(tag);
                }
              });
            }*/
          });
          console.log(this.tags);
        }          
      });
    });
      $('.page-contents').animate({ scrollRight: $('#levelOne').width() - 400 }, 400); 
  }
}